import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Fragment } from 'react';
import { Translate } from 'react-jhipster';
import { useDispatch } from 'react-redux';
import { Button, Col, Row } from 'reactstrap';
import PlaceMap from './PlaceMap';
import { reset } from 'app/entities/place/place.reducer';

export const Place = props => {
  const dispatch = useDispatch();
  return (
    <Fragment>
      <div className="d-flex justify-content-between align-items-center">
        <h4 id="fleetSenseApp.place.home.createOrEditLabel" data-cy="PlaceCreateUpdateHeading">
          {props.match.params && props.match.params.id ? (
            <Translate contentKey="fleetSenseApp.place.home.editLabel">Edit Place</Translate>
          ) : (
            <Translate contentKey="fleetSenseApp.place.home.createLabel">Create a new Place</Translate>
          )}
        </h4>
        <Row>
          <Button
            outline
            size="sm"
            replace
            color="info"
            data-cy="entityDetailsBackButton"
            onClick={() => {
              dispatch(reset());
              props.history.goBack();
            }}
          >
            <FontAwesomeIcon icon="arrow-left" />{' '}
            <span className="d-none d-md-inline">
              <Translate contentKey="entity.action.back">Back</Translate>
            </span>
          </Button>
        </Row>
      </div>
      <Row className="mt-2">
        <Col className="p-0">
          <PlaceMap props={props} />
        </Col>
      </Row>
    </Fragment>
  );
};
